<template>
  <div class="apply-page">
    <div class="apply-hero">
      <h1>企业信息申请</h1>
      <p>补充企业公开资料。提交后进入审核，预计 1–3 个工作日，请保持电话畅通。</p>
    </div>

    <el-form
      class="apply-card"
      v-loading="loading"
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="156px"
    >
      <div class="apply-head">
        <el-form-item prop="logoPicture" class="apply-avatar-item" label-width="0">
          <GsUpload
            v-model="ruleForm.logoPicture"
            kind="image"
            :limit="1"
            add-text="上传 Logo"
            tip="png / jpg，建议正方形"
          />
        </el-form-item>
        <div class="apply-head-fields">
          <el-row :gutter="16">
            <el-col :span="12">
              <el-form-item label="企业名称" prop="enterpriseName">
                <el-input v-model="ruleForm.enterpriseName" placeholder="请输入企业全称" maxlength="80" clearable />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="英文名称" prop="englishName">
                <el-input v-model="ruleForm.englishName" placeholder="选填" maxlength="120" clearable />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="企业简称" prop="enterpriseAbbreviation">
                <el-input v-model="ruleForm.enterpriseAbbreviation" placeholder="选填" maxlength="40" clearable />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="统一社会信用代码" prop="unifySocialCreditCode">
                <el-input v-model="ruleForm.unifySocialCreditCode" placeholder="请输入统一社会信用代码" maxlength="18" clearable />
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </div>

      <TitleTool title="主体信息" />
      <el-row :gutter="16">
        <el-col :span="12">
          <el-form-item label="企业类型" prop="typeOfEnterprise">
            <GsSelect v-model="ruleForm.typeOfEnterprise" class="wp100" placeholder="请选择企业类型" :options="typeOfEnterpriseEnum" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="企业属性" prop="type">
            <GsSelect v-model="ruleForm.type" class="wp100" multiple placeholder="请选择企业属性" :options="companyTypEnum" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="所属行业" prop="industry">
            <GsCascadeSelect
              v-model="ruleForm.industry"
              :options="industryEnum"
              placeholder="请选择所属行业，可清除"
              search-placeholder="搜索行业"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="行政区划" prop="administrativeDivision">
            <GsRegionSelect
              v-model="regionPath"
              class="wp100"
              placeholder="请选择省 / 市 / 区"
              @change="onRegionChange"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <TitleTool title="注册与资本" />
      <el-row :gutter="16">
        <el-col :span="12">
          <el-form-item label="成立日期" prop="dateOfEstablishment">
            <GsDate v-model="ruleForm.dateOfEstablishment" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="营业期限" prop="limitedTerm">
            <GsDate v-model="ruleForm.limitedTerm" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="注册资本" prop="registeredCapital">
            <el-input v-model="ruleForm.registeredCapital" placeholder="单位：万元" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="实缴资本" prop="contributedCapital">
            <el-input v-model="ruleForm.contributedCapital" placeholder="单位：万元" clearable />
          </el-form-item>
        </el-col>
      </el-row>

      <TitleTool title="地址与联系" />
      <el-row :gutter="16">
        <el-col :span="12">
          <el-form-item label="注册地区" prop="registeredAddress">
            <GsRegionSelect v-model="ruleForm.registeredAddress" placeholder="请选择注册地区，可清除" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="注册详细地址" prop="registeredAddressDetail">
            <el-input v-model="ruleForm.registeredAddressDetail" placeholder="街道、门牌等" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="办公地址" prop="officeAddress">
            <GsRegionAddress v-model="ruleForm.officeAddress" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="电话" prop="phone">
            <el-input v-model="ruleForm.phone" placeholder="手机号或座机" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="邮箱" prop="email">
            <el-input v-model="ruleForm.email" placeholder="选填" clearable />
          </el-form-item>
        </el-col>
      </el-row>

      <TitleTool title="企业简介" />
      <el-form-item label="公司简介" prop="companyProfile">
        <el-input
          v-model="ruleForm.companyProfile"
          type="textarea"
          :autosize="{ minRows: 4, maxRows: 8 }"
          maxlength="1500"
          show-word-limit
          placeholder="主营业务、服务范围与公开登记信息，不超过 1500 字"
        />
      </el-form-item>
    </el-form>

    <div class="apply-actions">
      <el-button @click="closePage">取消</el-button>
      <el-button type="primary" @click="saveCompany">提交申请</el-button>
    </div>
  </div>
</template>

<script>
import {
  getDataType,
  enterpriseInfoSave,
  normList
} from '@/api/Layout/index.js'
import { enumType } from '@/utils/enum.js'
import { findNode, loadRegionTree } from '@/utils/region'
import GsCascadeSelect from '@/components/GsCascadeSelect/index.vue'
import GsUpload from '@/components/GsUpload/index.vue'
import GsRegionAddress from '@/components/GsRegionAddress/index.vue'
import { gsConfirm } from '@/utils/gsConfirm'
import './apply-form.css'

export default {
  name: 'AddCompanyInfo',
  components: { GsCascadeSelect, GsUpload, GsRegionAddress },
  data() {
    const validatePhone = (rule, value, callback) => {
      if (!value) return callback(new Error('请输入电话'))
      const mobilePattern = /^1[3-9]\d{9}$/
      const telPattern = /^(\(\d{3,4}\)|\d{3,4}-?)?\d{7,8}$/
      if (mobilePattern.test(value) || telPattern.test(value)) callback()
      else callback(new Error('请输入正确的手机号或座机号'))
    }
    return {
      loading: false,
      typeOfEnterpriseEnum: [],
      industryEnum: [],
      companyTypEnum: [],
      administrativeDivisionList: [],
      /** 行政区划三级联动的已选路径（省 / 市 / 区县 代码） */
      regionPath: [],
      regionTree: [],
      ruleForm: {
        logoPicture: [],
        enterpriseName: '',
        englishName: '',
        enterpriseAbbreviation: '',
        administrativeDivision: '',
        dateOfEstablishment: '',
        operatingTerm: [],
        limitedTerm: '',
        registeredCapital: '',
        typeOfEnterprise: '',
        contributedCapital: '',
        officeAddress: '',
        industry: [],
        unifySocialCreditCode: '',
        registeredAddress: [],
        registeredAddressDetail: '',
        phone: '',
        email: '',
        type: [],
        companyProfile: ''
      },
      rules: {
        enterpriseName: [{ required: true, message: '请输入企业名称', trigger: ['blur', 'change'] }],
        administrativeDivision: [{ required: true, message: '请选择行政区划', trigger: ['blur', 'change'] }],
        dateOfEstablishment: [{ required: true, message: '请选择成立日期', trigger: ['blur', 'change'] }],
        limitedTerm: [{ required: true, message: '请选择营业期限', trigger: ['blur', 'change'] }],
        registeredCapital: [{ required: true, message: '请输入注册资本（单位：万元）', trigger: ['blur', 'change'] }],
        typeOfEnterprise: [{ required: true, message: '请选择企业类型', trigger: ['blur', 'change'] }],
        contributedCapital: [{ required: true, message: '请输入实缴资本（单位：万元）', trigger: ['blur', 'change'] }],
        officeAddress: [{ required: true, message: '请输入办公地址', trigger: ['blur', 'change'] }],
        industry: [{ required: true, type: 'array', min: 1, message: '请选择所属行业', trigger: ['blur', 'change'] }],
        unifySocialCreditCode: [{ required: true, message: '请输入统一社会信用代码', trigger: ['blur', 'change'] }],
        registeredAddress: [{ required: true, type: 'array', min: 1, message: '请选择注册地区', trigger: ['blur', 'change'] }],
        phone: [
          { required: true, message: '请输入电话', trigger: ['blur', 'change'] },
          { validator: validatePhone, trigger: ['blur', 'change'] }
        ],
        type: [{ required: true, type: 'array', min: 1, message: '请选择企业属性', trigger: ['blur', 'change'] }]
      }
    }
  },
  created() {
    this.getData('sys_enterprise_type')
    this.getData('sys_type')
    this.allGlobalRegionListArea()
    this.normListArea()
  },
  methods: {
    allGlobalRegionListArea() {
      loadRegionTree().then((tree) => {
        this.regionTree = tree || []
      }).catch(() => {
        this.regionTree = []
      })
    },
    /** 三级联动：行政区划存末级（区县）代码 */
    onRegionChange(path) {
      const list = Array.isArray(path) ? path : []
      this.regionPath = list
      const leaf = list.length ? findNode(this.regionTree, list[list.length - 1]) : null
      this.ruleForm.administrativeDivision = leaf ? String(leaf.value) : ''
    },
    normListArea() {
      normList().then((res) => {
        this.industryEnum = res && res.data ? res.data : []
      }).catch(() => {
        this.industryEnum = []
      })
    },
    async getData(type) {
      try {
        const res = await getDataType(type)
        const list = res && res.data && res.data.length ? enumType(res.data) : []
        if (type === 'sys_enterprise_type') this.typeOfEnterpriseEnum = list
        if (type === 'sys_type') this.companyTypEnum = list
      } catch (error) {
        console.error(error)
      }
    },
    joinFiles(list) {
      return Array.isArray(list) ? list.filter(Boolean).join(',') : (list || '')
    },
    saveCompany() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return
        const time1 = new Date(this.ruleForm.dateOfEstablishment)
        const time2 = new Date(this.ruleForm.limitedTerm)
        if (time1 > time2) {
          this.$message.warning('成立日期不能晚于营业期限')
          return
        }
        const payload = Object.assign({}, this.ruleForm, {
          operatingTerm: JSON.stringify([this.ruleForm.dateOfEstablishment, this.ruleForm.limitedTerm]),
          industry: Array.isArray(this.ruleForm.industry) ? JSON.stringify(this.ruleForm.industry) : this.ruleForm.industry,
          registeredAddress: Array.isArray(this.ruleForm.registeredAddress) ? JSON.stringify(this.ruleForm.registeredAddress) : this.ruleForm.registeredAddress,
          type: Array.isArray(this.ruleForm.type) ? JSON.stringify(this.ruleForm.type) : this.ruleForm.type,
          logoPicture: this.joinFiles(this.ruleForm.logoPicture)
        })
        gsConfirm({
          message: '确定提交企业信息申请吗？',
          confirmButtonText: '提交',
          cancelButtonText: '再看看'
        }).then(() => {
          this.loading = true
          enterpriseInfoSave(payload).then((res) => {
            this.loading = false
            if (res.code === 200) {
              this.$alert('申请已提交，审核需要 1–3 个工作日，请保持电话畅通。', '提交成功', {
                confirmButtonText: '我知道了'
              })
              this.$router.go(-1)
            }
          }).catch(() => {
            this.loading = false
          })
        }).catch(() => {})
      })
    },
    closePage() {
      gsConfirm({
        message: '确定离开本页吗？未提交的内容不会保存。',
        confirmButtonText: '离开',
        cancelButtonText: '继续填写'
      }).then(() => {
        this.$router.go(-1)
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.apply-avatar-item {
  margin-bottom: 0;
}
.apply-avatar-item :deep(.el-form-item__content) {
  margin-left: 0 !important;
  line-height: normal;
}
</style>
